"use client";

import "./BlocksRenderer.scss";

const cleanUrl = (url) => {
  if (!url) return "#";

  try {
    const parsedUrl = new URL(url);

    parsedUrl.searchParams.delete("_gl");
    parsedUrl.searchParams.delete("_gcl_au");

    return parsedUrl.toString();
  } catch {
    return url;
  }
};

const getBlockText = (children = []) => {
  return children
    .map((child) => {
      if (child.type === "link") {
        return getBlockText(child.children);
      }

      return child.text || "";
    })
    .join("");
};

const getTableKey = (blockText = "") => {
  const match = blockText.match(/^\{\{table:([a-zA-Z0-9_-]+)\}\}$/);

  return match?.[1] || null;
};

const renderTextStyle = (child, index) => {
  let textElement = <span>{child.text}</span>;

  if (child.bold) {
    textElement = <strong>{textElement}</strong>;
  }

  if (child.italic) {
    textElement = <em>{textElement}</em>;
  }

  if (child.underline) {
    textElement = <u>{textElement}</u>;
  }

  if (child.strikethrough) {
    textElement = <s>{textElement}</s>;
  }

  return <span key={index}>{textElement}</span>;
};

const renderChildren = (children = []) => {
  return children.map((child, index) => {
    if (child.type === "link") {
      return (
        <a
          key={index}
          href={cleanUrl(child.url)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {renderChildren(child.children)}
        </a>
      );
    }

    if (child.type === "text") {
      return renderTextStyle(child, index);
    }

    return null;
  });
};

const normalizeTable = (tableData) => {
  if (!tableData) return null;

  if (Array.isArray(tableData)) {
    return {
      columns: ["Before ERP", "After ERP"],
      rows: tableData.map((row) => [row.before, row.after]),
    };
  }

  return {
    columns: tableData.columns || [],
    rows: tableData.rows || [],
  };
};

const renderComparisonTable = (tableData) => {
  const normalizedTable = normalizeTable(tableData);

  if (!normalizedTable?.columns?.length || !normalizedTable?.rows?.length) {
    return null;
  }

  return (
    <div className="erp-comparison-table">
      <div className="table-responsive">
        <table>
          <thead>
            <tr>
              {normalizedTable.columns.map((column, index) => (
                <th key={`${column}-${index}`}>{column}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {normalizedTable.rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td
                    key={`${rowIndex}-${cellIndex}`}
                    data-label={normalizedTable.columns[cellIndex]}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const BlocksRenderer = ({
  content = [],
  comparisonTable = null,
  comparisonTable1 = null,
  comparisonTable2 = null,
  comparisonTable3 = null,
  comparisonTable4 = null,
  comparisonTable5 = null,
}) => {
  const tables = {
    comparisonTable1,
    comparisonTable2,
    comparisonTable3,
    comparisonTable4,
    comparisonTable5,
  };

  console.log("TABLE DATA:", {
    comparisonTable,
    comparisonTable1,
    comparisonTable2,
    comparisonTable3,
    comparisonTable4,
    comparisonTable5,
  });

  return (
    <div className="blocks-renderer">
      {content.map((block, index) => {
        const blockText = getBlockText(block.children).trim();
        const tableKey = getTableKey(blockText);

        if (blockText === "{{comparisonTable}}") {
          return (
            <div key={index}>{renderComparisonTable(comparisonTable)}</div>
          );
        }

        if (tableKey) {
          console.log("TABLE KEY:", tableKey);
          console.log("TABLE DATA FOR KEY:", tables[tableKey]);

          return (
            <div key={index}>{renderComparisonTable(tables[tableKey])}</div>
          );
        }
        switch (block.type) {
          case "heading": {
            if (block.level === 6) {
              return <h3 key={index}>{renderChildren(block.children)}</h3>;
            }

            if (block.level === 5) {
              return <h2 key={index}>{renderChildren(block.children)}</h2>;
            }

            return <h2 key={index}>{renderChildren(block.children)}</h2>;
          }

          case "paragraph":
            return <p key={index}>{renderChildren(block.children)}</p>;

          case "list":
            if (block.format === "ordered") {
              return (
                <ol key={index}>
                  {block.children?.map((item, itemIndex) => (
                    <li key={itemIndex}>{renderChildren(item.children)}</li>
                  ))}
                </ol>
              );
            }

            return (
              <ul key={index}>
                {block.children?.map((item, itemIndex) => (
                  <li key={itemIndex}>{renderChildren(item.children)}</li>
                ))}
              </ul>
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

export default BlocksRenderer;
